import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import App from './App';
import { bootstrapImpersonation } from './utils/impersonationSession';

import './scss/main.scss';
import './i18n';

// Must run before the router and the auth context read the URL and the tokens.
bootstrapImpersonation();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const theme = createTheme({
  palette: {
    primary: {
      main: '#e73d44',
    },
  },
});

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
);
